import React, { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import { ComboboxField } from '../../../Components/formElements/ComboboxField';
import Layout from "../../../Layout/Layout";
import { useNavigate } from "react-router-dom";
import Constants from "../../../common/CustomerConstants";

//Redux
import { useSelector } from "react-redux";
import { InputField } from "../../../Components/formElements/InputField";

//Serivce
import ItemService from "../../../services/inventory_appCommonService";
import DataTable from "react-data-table-component";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import { formatDate } from "../../../common/Validations";
import DraftModal from "../../../Components/CancleModal/DraftModal";
const IndentDetailPageWH = () => {
  const navigate = useNavigate();
  localStorage.setItem("menu", "Material");
  localStorage.setItem("submenu", "Material");
  const historyGuardRef = useRef(false);
  const initialFormRef = useRef(null);

  let inquiryID = useSelector((state) => state?.preSales?.inquiryID); // User Details from Store

  const [formInputs, setFormInputs] = useState({
    organisationName: "",
    companyName: "",
    email: "",
    firstName: "",
    lastName: "",
  });
  const status = formInputs?.headerStatus?.toLowerCase();

  const formInputsRef = useRef(formInputs);
  const hasFormChanges = () => {
    return JSON.stringify(formInputsRef.current) !== initialFormRef.current;
  };
  useEffect(() => {
    formInputsRef.current = formInputs;
  }, [formInputs]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  // const handleCancelClick = () => {
  //   setIsEditMode(false);
  // };

  const handleCancelClick = () => {
    if (hasFormChanges()) {
      setShowDraftModal(true);
    } else {
      setIsEditMode(false);
      historyGuardRef.current = false;
    }
  };
  const handleUpdateClick = () => {
    setIsEditMode(true);
  };
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const [showDraftModal, setShowDraftModal] = useState(false);

  const handleSaveClick = async () => {
    const toastId = toast.loading("Saving...", {
      position: "top-right",
    });

    try {
      const payload = {
        ...formInputs,
        // contactDetails: getcustomerContactPerson,
        // certifications: getDocumentTypeData,
      };

      const response = await ItemService.updateMatIndentDocument(payload);

      if (response?.status === 200) {
        toast.dismiss(toastId);
        toast.success("Warehouse updated successfully", {
          position: "top-right",
        });

        setIsEditMode(false);
        // loadIntialData1();
      } else {
        toast.dismiss(toastId);
        toast.error(response?.message || "Failed to update warehouse", {
          position: "top-right",
        });
      }
    } catch (error) {
      console.error(error);

      toast.dismiss(toastId);
      toast.error("Something went wrong. Please try again.", {
        position: "top-right",
      });
    }
  };

  useEffect(() => {
    const handlePopState = () => {
      if (isEditMode && hasFormChanges()) {
        setShowDraftModal(true);
        window.history.pushState(
          { draftModalGuard: true },
          "",
          window.location.href,
        );
      } else {
        setIsEditMode(false);
        historyGuardRef.current = false;
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isEditMode]);

  const handleDiscardDraft = () => {
    setShowDraftModal(false);
    setIsEditMode(false);
    historyGuardRef.current = false;
    loadFirstLevelData();
  };

  const handleSaveAsDraft = async (payload) => {
    const toastId = toast.loading("Saving as draft...", {
      position: "top-right",
    });

    try {
      const draftPayload = {
        ...payload,
        headerStatus: "Draft",
        status: "Draft",
      };

      const response = await ItemService.updateStockDocument(draftPayload);

      toast.dismiss(toastId);

      if (response?.status === 200) {
        toast.success("Saved as draft successfully", {
          position: "top-right",
        });
        setShowDraftModal(false);
        setIsEditMode(false);
        initialFormRef.current = JSON.stringify(formInputs);
        historyGuardRef.current = false;
        loadFirstLevelData();
      } else {
        toast.error(response?.message || "Failed to save draft", {
          position: "top-right",
        });
      }

      return response;
    } catch (error) {
      console.error(error);
      toast.dismiss(toastId);
      toast.error("Something went wrong. Please try again.", {
        position: "top-right",
      });
      throw error;
    }
  };
  // eslint-disable-next-line
  const [getDisabledStatus, setDisabledStatus] = useState(true);
  const loadFirstLevelData = async (page) => {
    if (inquiryID) {
      let obj = {
        documentNumber: inquiryID,
      };
      await ItemService.getIndentDetail(obj).then((item) => {
        if (item?.status === 200) {
          // console.log(">> item", item);
          setDisabledStatus(true);
          setFormInputs(item?.data[0]);
        } else {
          setFormInputs([]);
          console.log(">> Error: Loading getCategory");
        }
      });
    } else {
      navigate(Constants.PRESALES_INQUIRY_LIST);
    }
  };

  useEffect(() => {
    loadFirstLevelData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Commmon OnChange of the input scetion
  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
  };

  const columns = [
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "150px",
    },
    {
      // name: "Material Description",
      name: (
        <>
          <i className="bi bi-box-seam labelIcon"></i>
          Material/Service
        </>
      ),
      selector: (row) => row.materialDescription,
      sortable: true,
      width: "200px",
    },
    {
      // name: "Material Group",
      name: (
        <>
          <i className="bi bi-collection labelIcon"></i>
          Material Group
        </>
      ),
      selector: (row) => row.materialGroup,
      sortable: true,
      width: "180px",
    },
    {
      // name: "Inquiry Quantity",
      name: (
        <>
          <i className="bi bi-123 labelIcon"></i>
          Quantity
        </>
      ),
      selector: (row) => row.indentQty,
      sortable: true,
      width: "180px",
    },
    {
      // name: "Oder Unit",
      name: (
        <>
          <i className="bi bi-rulers labelIcon"></i>
          UOM
        </>
      ),
      selector: (row) => row.orderUnitOfMeasure,
      sortable: true,
      width: "120px",
    },
    {
      // name: "Delivery Date",
      name: (
        <>
          <i className="bi bi-calendar-check labelIcon"></i>
          Delivery Date
        </>
      ),
      selector: (row) => row.deliveryDate,
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">
            {formatDate(row.deliveryDate) || "--"}
          </span>
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      // name: "Plant /Location",
      name: (
        <>
          <i className="bi bi-building labelIcon"></i>
          Plant
        </>
      ),
      selector: (row) => row.plant,
      sortable: true,
      width: "250px",
    },
  ];
  const handleConvertToStock = async () => {
    let obj = {
      data: formInputs,
      type: "Save",
    };
    await ItemService.addMatIndent(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 8000,
          position: "top-right",
        });
        // navigate(wa.INVENTORY_STOCK_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      // setDisabled(false);
    });
  };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              Indent Details :{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {inquiryID}
              </span>
              <span>
                {formInputs?.headerStatus === "Created" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : formInputs?.headerStatus === "Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : formInputs?.headerStatus === "Deleted" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : formInputs?.headerStatus === "Completed" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : formInputs?.headerStatus === "Draft" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : formInputs?.headerStatus === "Deactivated" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : (
                  formInputs?.headerStatus
                )}
              </span>
            </h2>
            <p className="subText">Indent Information </p>
            <Row className="mb-2">
              <Col xs={12} className="d-flex justify-content-end gap-2">
                {!isEditMode ? (
                  <button
                    className="btnTable btn-update"
                    onClick={handleUpdateClick}
                    disabled={["deleted", "cancelled"].includes(status)}
                  >
                    <i className="bi bi-pencil-square"></i> Modify
                  </button>
                ) : (
                  <>
                    <button
                      className="btnTable btn-update"
                      onClick={
                        status === "draft"
                          ? handleConvertToStock
                          : handleSaveClick
                      }
                    >
                      <i
                        className={`bi ${status === "draft" ? "bi-arrow-repeat" : "bi-save"}`}
                      ></i>
                      {status === "draft" ? " Convert to Indent" : " Save"}
                    </button>

                    <button
                      className="btn btn-secondary btn-update"
                      onClick={handleCancelClick}
                    >
                      <i className="bi bi-x-circle"></i> Cancel
                    </button>
                  </>
                )}
              </Col>
            </Row>
            <hr />
            {/* 01 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">HR</span>
                    </Col>
                    <Col className="flex-grow-1">
                      <span className="headerTitle">Header Details</span>
                      <span className="subHeaderTitle">
                        Indent Basic Information
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Status"
                          label={
                            <>
                              <i className="bi bi-check-circle labelIcon"></i>
                              Status
                            </>
                          }
                          name="inqHeaderstatus"
                          placeholder=""
                          value={formInputs.inqHeaderstatus || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Sold to Party"
                          type="text"
                          name="soldToParty"
                          placeholder=""
                          value={formInputs.customerCode || ""}
                          onChange={onInputChange}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Ship to Party"
                          name="shipToParty"
                          placeholder=""
                          value={formInputs.customerCode || ""}
                          onChange={onInputChange}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Customer Code"
                          label={
                            <>
                              <i className="bi bi-person-badge labelIcon"></i>
                              Customer Code
                            </>
                          }
                          name="customerCode"
                          placeholder=""
                          value={formInputs.customerCode || ""}
                          onChange={onInputChange}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Customer Name"
                          label={
                            <>
                              <i className="bi bi-person labelIcon"></i>
                              Customer Name
                            </>
                          }
                          name="customerName"
                          placeholder=""
                          value={formInputs.customerName || ""}
                          onChange={onInputChange}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Order Type"
                          label={
                            <>
                              <i className="bi bi-cart-check labelIcon"></i>
                              Order Type
                            </>
                          }
                          name="orderType"
                          placeholder=""
                          value={formInputs.salesType || ""}
                          onChange={onInputChange}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Request Delivery Date"
                          label={
                            <>
                              <i className="bi bi-calendar-check labelIcon"></i>
                              Request Delivery Date
                            </>
                          }
                          name="requestDeliveryDate"
                          placeholder=""
                          value={formInputs.reqestDeliveryDate || ""}
                          onChange={onInputChange}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Payment Terms"
                          label={
                            <>
                              <i className="bi bi-credit-card labelIcon"></i>
                              Payment Terms
                            </>
                          }
                          name="paymentTerms"
                          placeholder=""
                          value={formInputs.paymentTerms || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Company Code"
                          label={
                            <>
                              <i className="bi bi-building labelIcon"></i>
                              Company Code
                            </>
                          }
                          name="companyCode"
                          placeholder=""
                          value={formInputs.companyCode || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Sales Organization"
                          label={
                            <>
                              <i className="bi bi-shop labelIcon"></i>
                              Sales Organization
                            </>
                          }
                          name="salesOrg"
                          placeholder=""
                          value={formInputs.salesOrg || ""}
                          onChange={onInputChange}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Distribution Channel"
                          label={
                            <>
                              <i className="bi bi-diagram-2 labelIcon"></i>
                              Distribution Channel
                            </>
                          }
                          name="disrtibutionChannel"
                          placeholder=""
                          value={formInputs.disrtibutionChannel || ""}
                          onChange={onInputChange}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Division"
                          label={
                            <>
                              <i className="bi bi-grid-3x3-gap labelIcon"></i>
                              Division
                            </>
                          }
                          name="division"
                          placeholder=""
                          value={formInputs.division || ""}
                          onChange={onInputChange}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          // label="Remark"
                          label={
                            <>
                              <i className="bi bi-chat-left-text labelIcon"></i>
                              Indent Remarks
                            </>
                          }
                          type="text"
                          name="indentRemarks"
                          id="indentRemarks"
                          placeholder=""
                          value={formInputs?.indentRemarks || ""}
                          onChange={onInputChange}
                          disabled={!isEditMode}
                        />
                      </Col>

                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="initiator By"
                          name="initiatedBy"
                          placeholder=""
                          value={formInputs.initiatedBy || ""}
                          onChange={onInputChange}
                           disabled={!isEditMode}
                        />
                      </Col> */}
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* 02 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LI</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Line Item / Products</span>
                      <span className="subHeaderTitle">
                        Line Item / Products Details
                      </span>
                    </Col>
                    {/* {formInputs?.inqHeaderstatus === "New" && (
                      <Col xs={1} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={() => handleAcknowledgeClick()}
                          disabled={disabled}
                        >
                          Acknowledged
                        </button>
                      </Col>
                    )} */}
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={formInputs?.items}
                          // progressPending={purchaseOrderData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          // paginationTotalRows={purchaseOrderTable.total}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <DraftModal
        show={showDraftModal}
        onHide={() => setShowDraftModal(false)}
        type="stock"
        title="Save as Draft"
        formData={formInputs}
        onConfirm={handleSaveAsDraft}
        onDiscard={handleDiscardDraft}
      />
    </main>
  );
};

export default IndentDetailPageWH;
